import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-we" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "title-main" }
const _hoisted_5 = { class: "subtitle-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, "Stage " + _toDisplayString($setup.stage ? $setup.stage.title : ""), 1),
        _createElementVNode("h3", _hoisted_5, _toDisplayString($setup.plural($setup.lots.length, "lot")), 1)
      ])
    ]),
    _createVNode($setup["LotsTable"], {
      lots: $setup.lots,
      isLoading: $setup.isLoading,
      lotList: $setup.lotList,
      selectedLotsList: $setup.selectedLotsList,
      showCreateOption: $setup.showCreateOption,
      isSelectAll: $setup.isSelectAll,
      columnsArray: $setup.columnsArray,
      editingLot: $setup.editingLot,
      editingField: $setup.editingField,
      editingValue: $setup.editingValue,
      fieldsConfig: $setup.fieldsConfig,
      columnInputTypeMap: $setup.columnInputTypeMap,
      getFieldType: $setup.getFieldType,
      getColumnValue: $setup.getColumnValue,
      getColumnDisplayValue: $setup.getColumnDisplayValue,
      isFieldEditable: $setup.isFieldEditable,
      getFieldOptions: $setup.getFieldOptions,
      activeFilter: $setup.activeFilter,
      filters: $setup.filters,
      onClickAction: $setup.clickAction,
      onToggleCustomizeColumns: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCustomizeColumnsModal = true)),
      onSelectAll: $setup.selectAll,
      onSelectLot: $setup.selectLot,
      onSaveEdit: $setup.saveEdit,
      onCancelEdit: $setup.cancelEdit,
      onStartEditing: $setup.startEditing,
      onUpdateEditingValue: $setup.updateEditingValue,
      onGoBack: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push({ name: 'StagesV2' }))),
      onChangeFilter: $setup.handleFilterChange,
      onOpenEditPriceModal: $setup.openEditPriceModal,
      onBulkStatusUpdate: $setup.bulkStatusUpdate,
      onCancelHold: $setup.handleCancelHold,
      onBulkCancelHold: $setup.handleBulkCancelHold,
      onSetHold: $setup.handleSetHold,
      onBulkSetHold: $setup.handleBulkSetHold,
      onBulkSetHoldWithBuyers: $setup.handleBulkSetHoldWithBuyers,
      onRefreshLotDocuments: $setup.handleRefreshLotDocuments
    }, null, 8, ["lots", "isLoading", "lotList", "selectedLotsList", "showCreateOption", "isSelectAll", "columnsArray", "editingLot", "editingField", "editingValue", "fieldsConfig", "columnInputTypeMap", "getFieldType", "getColumnValue", "getColumnDisplayValue", "isFieldEditable", "getFieldOptions", "activeFilter", "filters", "onClickAction", "onSelectAll", "onSelectLot", "onSaveEdit", "onCancelEdit", "onStartEditing", "onUpdateEditingValue"]),
    _createVNode($setup["CustomizeColumnsModal"], {
      isOpen: $setup.showCustomizeColumnsModal,
      columns: $setup.columnsArray,
      customColumns: $setup.customColumns,
      isUpdating: $setup.isUpdating,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showCustomizeColumnsModal = false)),
      onUpdateColumns: _cache[3] || (_cache[3] = async (update) => await $setup.handleColumnUpdate(update))
    }, null, 8, ["isOpen", "columns", "customColumns", "isUpdating"]),
    _createVNode($setup["ReleaseLotsModal"], {
      onClose: $setup.closeReleaseModal,
      isOpen: $setup.showReleaseModal,
      showClose: false,
      listForUpdate: $setup.selectedForReleaseList,
      stageId: $setup.stageId
    }, null, 8, ["onClose", "isOpen", "listForUpdate", "stageId"]),
    _createVNode($setup["CreateOptionModal"], {
      onClose: $setup.closeCreateOptionModal,
      isOpen: $setup.showCreateOptionModal,
      showClose: false,
      listForUpdate: $setup.selectedForOptionList,
      registrationDate: $setup.registrationDate
    }, null, 8, ["onClose", "isOpen", "listForUpdate", "registrationDate"]),
    _createVNode($setup["SetRegistrationDateModal"], {
      onClose: $setup.closeRegDateModal,
      isOpen: $setup.showRegDateModal,
      showClose: false,
      listForUpdate: $setup.lotList,
      onUpdate: $setup.onUpdateRegistrationDate
    }, null, 8, ["onClose", "isOpen", "listForUpdate", "onUpdate"]),
    _createVNode($setup["TransitionModal"], {
      onProceed: $setup.proceed,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showTransitionModal = false)),
      isOpen: $setup.showTransitionModal,
      showClose: false,
      attentionType: $setup.attentionType
    }, null, 8, ["onProceed", "isOpen", "attentionType"]),
    _createVNode($setup["EditPriceModal"], {
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.showEditPriceModal = false)),
      onSave: $setup.handlePriceSave,
      isOpen: $setup.showEditPriceModal,
      initialPricingType: $setup.editPriceData.type,
      initialValue: $setup.editPriceData.value
    }, null, 8, ["isOpen", "initialPricingType", "initialValue"])
  ]))
}